// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ErrorOutlineRounded } from '@/constants/hardfin-standard-icons';
import { Project } from '@/project/api/types';
import { Chip, Fade, Tooltip } from '@mui/material';

type RenewableProject = Pick<Project, 'name' | 'customer'>;

interface Props {
  project: RenewableProject;
  renewal: RenewableProject | null;
}

export function ProjectRenewalCustomerWarning(props: Props) {
  const isOpen =
    props.renewal !== null &&
    props.project.customer?.id !== props.renewal.customer?.id;

  const title =
    props.renewal === null ? null : (
      <>
        The customer on <b>{props.project.name}</b> (
        {props.project.customer?.name ?? 'None'}) does not match the customer on{' '}
        <b>{props.renewal.name}</b> ({props.renewal.customer?.name ?? 'None'}).
        You may want to confirm this change.
      </>
    );

  return (
    <Fade in={isOpen}>
      <Tooltip arrow placement="bottom" title={title}>
        <Chip
          size="small"
          color="warning"
          label="Notice"
          variant="outlined"
          icon={<ErrorOutlineRounded fontSize="small" color="warning" />}
        />
      </Tooltip>
    </Fade>
  );
}
